import { gql } from '@/__generated__';

export const GET_UPDATE_DEVICE_OPERATIONAL_STATE = gql(`#graphql
query GetUpdateDeviceOperationalState($deviceId: ID!) {
  device(input: { id: $deviceId }) {
    id
    profile {
      id
      operationalState
    }
  }
}`);
